window.addEventListener('scroll', function() {
  var header = document.querySelector('.section-header');
  var sidebar = document.querySelector('.custom-collection_cart_sidebar');

  if (header) {
    var headerBottom = header.getBoundingClientRect().bottom;
    
    // Check if section-header is out of view
    if (headerBottom <= 0) {
      sidebar.classList.add('active');
    } else {
      sidebar.classList.remove('active');
    }
  }
});


// product page image magnifier js starts 
let scrollListener = null;

function setupScrollListener() {
    const header = document.querySelector('.section-header');
    const sidebar = document.querySelector('.custom-collection_cart_sidebar');

    const onScroll = () => {
        if (header) {
            const headerBottom = header.getBoundingClientRect().bottom;

            if (headerBottom <= 0) {
                sidebar.classList.add('active');
            } else {
                sidebar.classList.remove('active');
            }
        }
    };

    window.addEventListener('scroll', onScroll);
    return onScroll;
}

function magnify(zoom) {
    const initializeMagnifier = (img) => {
        if (img.parentElement.querySelector('.img-magnifier-glass')) return;

        const glass = document.createElement("DIV");
        glass.className = "img-magnifier-glass";
        img.parentElement.insertBefore(glass, img);

        glass.style.background = `url('${img.src}')`;
        glass.style.backgroundRepeat = "no-repeat";
        glass.style.backgroundSize = `${img.width * zoom}px ${img.height * zoom}px`;
        glass.style.display = 'none';
        glass.style.position = 'absolute';
        glass.style.pointerEvents = 'none';

        const bw = 3;
        const w = 100;
        const h = 100;

        const moveMagnifier = (e) => {
            e.preventDefault();
            const pos = getCursorPos(e);
            let x = Math.max(Math.min(pos.x, img.width - w / zoom), w / zoom);
            let y = Math.max(Math.min(pos.y, img.height - h / zoom), h / zoom);

            glass.style.left = `${x - w / 2}px`;
            glass.style.top = `${y - h / 2}px`;
            glass.style.backgroundPosition = `-${x * zoom - w / 2 + bw}px -${y * zoom - h / zoom + bw}px`;

            if (glass.style.display === 'none') {
                glass.style.display = 'block';
            }
        };

        const getCursorPos = (e) => {
            const a = img.getBoundingClientRect();
            const x = e.pageX || (e.touches[0].pageX);
            const y = e.pageY || (e.touches[0].pageY);
            return { x: x - a.left - window.pageXOffset, y: y - a.top - window.pageYOffset };
        };

        const hideMagnifier = () => {
            glass.style.display = 'none';
        };

        img.addEventListener("mousemove", moveMagnifier);
        img.addEventListener("mouseenter", () => {
            glass.style.display = 'block';
            img.style.cursor = "none";
        });
        img.addEventListener("mouseleave", hideMagnifier);
        img.addEventListener("touchmove", moveMagnifier);
        img.addEventListener("touchstart", (e) => {
            moveMagnifier(e);
            glass.style.display = 'block';
            img.style.cursor = "none";
        });
        img.addEventListener("touchend", hideMagnifier);
    };

    const images = document.querySelectorAll(".slider__slide.is-active .product__media img");
    images.forEach((img) => {
        if (img.complete) {
            initializeMagnifier(img);
        } else {
            img.addEventListener("load", () => initializeMagnifier(img));
        }
    });
}

const applyMagnificationIfActive = () => {
    const activeSlides = document.querySelectorAll(".slider__slide.is-active .product__media img");
    if (activeSlides.length) {
        magnify(2);
    }
};

const checkWindowWidth = () => {
    if (window.innerWidth > 768) {
        if (!scrollListener) {
            scrollListener = setupScrollListener();
            applyMagnificationIfActive();
            const observer = new MutationObserver(applyMagnificationIfActive);
            observer.observe(document.querySelector('.slider__slide'), { attributes: true, subtree: true });
        }
    } else {
        if (scrollListener) {
            window.removeEventListener('scroll', scrollListener);
            scrollListener = null;
        }
        const magnifiers = document.querySelectorAll('.img-magnifier-glass');
        magnifiers.forEach(glass => glass.remove());
    }
};

checkWindowWidth();
window.addEventListener('resize', checkWindowWidth);


// product page image magnifier js ends

// Footer Toggle Js 

//  $(document).ready(function () {
//    $('.custom-product-accordion').on('click', '.custom-acc-header', function () {
//      $(this).closest('.custom-acc-item')
//       .toggleClass('active')
//        .find('.custom-acc-body')
//        .not('.footer-acc-list')
//        .slideToggle();
//   });
// });

//product accordian code
$(document).on('click', '.quick-add-modal__content-info .custom-acc-header', function () {
  var item = $(this).closest('.custom-acc-item');
  var parent = item.closest('.quick-add-modal__content-info');

  if (item.hasClass('active')) return;

  parent.find('.custom-acc-item').removeClass('active');
  parent.find('.custom-acc-body').slideUp();

  item.addClass('active');
  item.find('.custom-acc-body').slideDown();
});

$(document).ready(function () {

  $('.custom-acc-item:first').addClass('active')
    .find('.custom-acc-body').show();

  $('.custom-product-accordion').on('click', '.custom-acc-header', function () {

    var currentItem = $(this).closest('.custom-acc-item');

    if (currentItem.hasClass('active')) return;

    $('.custom-acc-item')
      .removeClass('active')
      .find('.custom-acc-body')
      .slideUp();

    currentItem
      .addClass('active')
      .find('.custom-acc-body')
      .slideDown();

  });

});

//popup accordian code
$(document).on('click', '.quick-add-modal__content-info .custom-acc-header', function () {
  var item = $(this).closest('.custom-acc-item');
  var parent = item.closest('.quick-add-modal__content-info');

  if (item.hasClass('active')) return;

  parent.find('.custom-acc-item').removeClass('active');
  parent.find('.custom-acc-body').slideUp();

  item.addClass('active');
  item.find('.custom-acc-body').slideDown();
});



